import React from 'react';
import InitializeReacti18n from './i18n';

function I18nWrapper({ children }) {
	InitializeReacti18n();

	return <>{children}</>;
}

export default I18nWrapper;
